import type { TrafficChangesDTO } from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficChangesDTO";
import type { TrafficNewMarketsDTO } from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficNewMarketsDTO";
import createTrafficSignalFiltersViewResolver from "app/pages/sales-intelligence/sub-modules/signals/services/traffic-signals-filters-view-resolver/factory";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { ICountryObject } from "app/services/CountryService";

import { selectSignalsDescription } from "../../../sub-modules/signals/store/selectors";

type Deps = {
    countries: readonly ICountryObject[];
};

export default function useTrafficSignalFiltersViewResolver(deps: Deps) {
    const signalsDescription = useSelector(selectSignalsDescription);

    return useMemo(() => {
        return createTrafficSignalFiltersViewResolver({
            countries: deps.countries,
            trafficChanges: signalsDescription?.trafficChanges ?? ({} as TrafficChangesDTO),
            newMarkets: signalsDescription?.newMarkets ?? ({} as TrafficNewMarketsDTO),
        });
    }, [deps.countries, signalsDescription]);
}
